import { api, post } from '../../service';
import { DIALOG_ADD } from '../../libs/enum';

const defaultState = () => ({
    dialog: {
        visible: false,
        type: DIALOG_ADD,
    },
    form: {
        versionId: 0,
        deviceType: '',
        version: '',
        detail: '',
        file: null,
    },
    search: {
        size: 10,
        page: 1,
        key: '',
    },
    total: 0,
    versions: [],
});

const version = {
    namespaced: true,
    state: defaultState(),
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },
        async getVersions({ commit }, data) {
            const res = await post(api.version.list, data);
            commit('changeVersions', res);
        },
        async addVersion({ dispatch, state }) {
            const params = state.form;
            await post(api.version.add, params);
            dispatch('getVersions', state.search);
            dispatch('changeDialog', { visible: false });
        },
        async updateVersion({ dispatch, state }) {
            await post(api.version.update);
            dispatch('getVersions', state.search);
            dispatch('changeDialog', { visible: false });
        },
        async onlineVersion({ dispatch, state }, data) {
            await post(api.version.online, data);
            dispatch('getVersions', state.search);
        },
        changeDialog({ commit }, data) {
            commit('changeDialog', data);
        },
        changeForm({ commit }, data) {
            commit('changeForm', data);
        },
        changeSearch({ commit, dispatch, state }, data) {
            commit('changeSearch', data);
            dispatch('getVersions', state.search);
        },
    },
    mutations: {
        resetState(state) {
            Object.assign(state, defaultState());
        },
        changeVersions(state, data) {
            const { versions, totalCount } = data;
            state.total = totalCount;
            state.versions = versions;
        },
        changeDialog(state, data) {
            Object.assign(state.dialog, data);
        },
        changeForm(state, data) {
            Object.assign(state.form, data);
        },
        changeSearch(state, data) {
            Object.assign(state.search, data);
        },
    },
};

export default version;
